import AdobeIcon from '/imports/checkout/ui/assets/AdobeIcon';
import AiIcon from '/imports/checkout/ui/assets/AiIcon';
import {
  Card1Svg,
  Card2Svg,
  Card3Svg,
  Card4Svg,
  Card5Svg,
  Card6Svg,
} from '/imports/checkout/ui/assets/BluePillCheckoutCardsIcon';
import {
  CheckoutCtaListIcon1,
  CheckoutCtaListIcon2,
  CheckoutCtaListIcon3,
} from '/imports/checkout/ui/assets/CheckoutCtaListIcons';
import Clothes from '/imports/checkout/ui/assets/Clothes';
import DeltaAirIcon from '/imports/checkout/ui/assets/DeltaAirIcon';
import GoogleIcon from '/imports/checkout/ui/assets/GoogleIcon';
import IkeaIcon from '/imports/checkout/ui/assets/IkeaIcon';
import LikeIcon from '/imports/checkout/ui/assets/LikeIcon';
import { EqualToIcon, ReviewIcon, UpArrowIcon } from '/imports/checkout/ui/assets/MergeDesignIcons';
import MicroSoftIcon from '/imports/checkout/ui/assets/MicroSoftIcon';
import {
  NewlyIcon1,
  NewlyIcon2,
  NewlyIcon3,
  NewlyIcon4,
  NewlyIcon5,
  NewlyIcon6,
} from '/imports/checkout/ui/assets/NewlyCheckoutIcons';
import PdfIcon from '/imports/checkout/ui/assets/PdfIcon';
import { ResumeIO1, ResumeIO2, ResumeIO3, ResumeIO4, ResumeIO5 } from '/imports/checkout/ui/assets/ResumeIoIcons';
import SupportIcon from '/imports/checkout/ui/assets/SupportIcon';
import Texi from '/imports/checkout/ui/assets/Texi';
import { Design1Icon1, Design1Icon2, Design1Icon3 } from '/imports/checkout/ui/assets/UpsellPageIcons';
import UserTrade from '/imports/checkout/ui/assets/UserTrade';
import { FEF_HOST, staticFile } from '/lib/helpers';

// Checkout A/B experiments
export const EXPERIMENT_1 = 'EXP 1';
export const EXPERIMENT_1A = 'EXP 1A';
export const EXPERIMENT_2 = 'EXP 2';
export const EXPERIMENT_3 = 'EXP 3';
export const EXPERIMENT_5 = 'EXP 5';
export const EXPERIMENT_4 = 'EXP 4';
export const EXPERIMENT_6 = 'EXP 6';
export const EXPERIMENT_7 = 'EXP 7';
export const EXPERIMENT_8 = 'EXP 8';
export const EXPERIMENT_9 = 'EXP 9';
export const EXPERIMENT_10 = 'EXP 10';
export const EXPERIMENT_11 = 'EXP 11';
export const EXPERIMENT_12 = 'EXP 12';
export const EXPERIMENT_13 = 'EXP 13';
export const EXPERIMENT_14 = 'EXP 14';
export const EXPERIMENT_15 = 'EXP 15';
export const EXPERIMENT_16 = 'EXP 16';
export const EXPERIMENT_17 = 'EXP 17';
export const EXPERIMENT_18 = 'EXP 18';
export const EXPERIMENT_19 = 'EXP 19';
export const EXPERIMENT_20 = 'EXP 20';
export const EXPERIMENT_21 = 'EXP 21';
export const EXPERIMENT_22 = 'EXP 22';
export const EXPERIMENT_23 = 'EXP 23';
export const EXPERIMENT_24 = 'EXP 24';
export const EXPERIMENT_27 = 'EXP 27';
export const EXPERIMENT_28 = 'EXP 28';
export const EXPERIMENT_25 = 'EXP 25';
export const EXPERIMENT_26 = 'EXP 26';

// list of PSP's billing version which should have the experiement 3, STRIPE:1, SOLID:5
export const NEW_PRICING_EXP_3_BILLING_VERSIONS = [5];

//list of country with close pricing exp
export const CLOSE_PRICING_COUNTRY = [
  'AR',
  'EC',
  'EG',
  'BR',
  'ID',
  'LT',
  'MX',
  'MA',
  'PH',
  'SA',
  'ES',
  'SE',
  'TH',
  'AE',
  'LV',
  'NL',
  'NO',
  'CL',
  'CO',
  'PE',
  'FR',
  'LB',
  'JP',
  'KR',
];

export const CLOSE_PRICING_COUNTRY_BROWSER_ONLY_NEW_BROWSER = ['CL'];

export const NEW_PRICING_FOR_BOTH = ['BR', 'ID', 'LT', 'MX', 'MA', 'PH', 'SA', 'ES', 'AE', 'LV', 'NL'];

export const NEW_PRICE_FOR_BROWSER_AND_RUN_MOBILE = ['ZA'];

export const CONTROL_BROSWER_RUN_MOBILE = ['AU'];

export const NEW_PRICE_ON_BROWSWER_CONTROL_MOBILE = ['FR'];

// Chargebee payment plan experiments
export const CB_EXPERIMENT_1 = 'EXP_1';

export const CARD_DETAILS_FIELD_STATES = {
  COMPLETE: 'complete',
  EMPTY: 'empty',
  INCOMPLETE: 'incomplete',
};

export const CARD_LOGOS = {
  visa: staticFile('img/visa.png'),
  mastercard: staticFile('img/mastercard.png'),
};

export const DISABLE_CHECKOUT_PRICING = ['TR', 'VN', 'PK', 'BR', 'PE', 'MX', 'TH', 'BD', 'IN'];

export const PAYMENT_CONTENT = [
  { icon: <LikeIcon />, content: 'payment_content_1' },
  { icon: <PdfIcon />, content: 'payment_content_2' },
  { icon: <AiIcon />, content: 'payment_content_3' },
  { icon: <SupportIcon />, content: 'payment_content_4' },
];

export const USER_RATING_INFORMATION = [
  {
    imageUrl: staticFile(`img/hero4.jpg`),
    userName: 'RAJENDRA',
  },
  {
    imageUrl: staticFile(`img/hero5.jpg`),
    userName: 'JULIE',
  },
  {
    imageUrl: staticFile(`img/hero6.jpg`),
    userName: 'ASHLEY',
  },
];

export const NEW_CHECKOUT_TESTIMONIAL = [
  {
    src: staticFile('img/checkout/avatar-1.jpg'),
    text: 'testimonial1',
    author: 'new_checkout_testimonial_female_name',
    job: 'sales_manager',
  },
  {
    src: staticFile('img/checkout/avatar-2.jpg'),
    text: 'testimonial2',
    author: 'new_checkout_testimonial_male_name',
    job: 'accountant',
  },
];

export const NEW_CHECKOUTPAGE_PRICING_POINTS = [
  { title: 'new_checkout_pricing_point_title_1', subTitle: `new_checkout_pricing_point_subtitle_1` },
  {
    title: 'new_checkout_pricing_point_title_2',
    subTitle: `new_checkout_pricing_point_subtitle_2`,
  },
  {
    title: 'new_checkout_pricing_point_title_3',
    subTitle: `new_checkout_pricing_point_subtitle_3`,
  },
  {
    subTitle: `new_checkout_pricing_point_subtitle_4`,
  },
  {
    subTitle: `new_checkout_pricing_point_subtitle_5`,
  },
];

export const NEW_CHECKOUT_MOBILE_POINT_SECTION = [
  { title: 'mobile_new_checkout_left_point_1' },
  { title: 'mobile_new_checkout_left_point_2' },
  { title: 'mobile_new_checkout_left_point_3' },
  { title: 'newly_left_subtitle_6' },
  { title: 'mobile_new_checkout_left_point_5' },
];

export const NEWLY_LEFT_SECTION_DATA = [
  {
    icon: <NewlyIcon1 />,
    title: 'newly_left_title_1',
    subTitle: 'newly_left_subtitle_1',
    autoApplyIcon: '🚀',
    autoApplytitle: 'offer_title_1',
    autoApplySubtitle: 'offer_title_1_1',
  },
  {
    icon: <NewlyIcon2 />,
    title: 'newly_left_title_2',
    subTitle: 'newly_left_subtitle_2',
    autoApplyIcon: '💼',
    autoApplytitle: 'offer_title_2',
    autoApplySubtitle: 'offer_title_2_1',
  },
  {
    icon: <NewlyIcon3 />,
    title: 'newly_left_title_3',
    subTitle: 'newly_left_subtitle_3',
    autoApplyIcon: '📝',
    autoApplytitle: 'offer_title_3',
    autoApplySubtitle: 'offer_title_3_1',
  },
  {
    icon: <NewlyIcon4 />,
    title: 'newly_left_title_4',
    subTitle: 'newly_left_subtitle_4',
    autoApplyIcon: '🎯',
    autoApplytitle: 'offer_title_4',
    autoApplySubtitle: 'offer_title_4_1',
  },
  {
    icon: <NewlyIcon5 />,
    title: 'newly_left_title_5',
    autoApplyIcon: '📊',
    autoApplytitle: 'offer_title_5',
    autoApplySubtitle: 'offer_title_5_1',
  },
  {
    icon: <NewlyIcon6 />,
    title: 'newly_left_title_6',
    subTitle: 'newly_left_subtitle_6',
    autoApplyIcon: '🧰',
    autoApplytitle: 'offer_title_6',
    autoApplySubtitle: 'offer_title_6_1',
  },
];

export const NEW_RIGHT_SECTION_SUB_DATA = [
  {
    icon: <NewlyIcon1 />,
    title: 'new_right_title1',
    subTitle: 'new_right_sub_title1',
  },
  {
    icon: <NewlyIcon4 />,
    title: 'new_right_title2',
    subTitle: 'new_right_sub_title2',
  },
  {
    icon: <NewlyIcon2 />,
    title: 'new_right_title3',
    subTitle: 'new_right_sub_title3',
  },
];

export const NEW_CHECKOUT_CTA_BOTTOM_LIST = [
  { icon: <CheckoutCtaListIcon1 />, title: 'new_checkout_cta_bottom_list_1' },
  { icon: <CheckoutCtaListIcon2 />, title: 'new_checkout_cta_bottom_list_2' },
  { icon: <CheckoutCtaListIcon3 />, title: 'new_checkout_cta_bottom_list_3' },
];

export const ACTIVE_PAYPAL_GEO = [
  'AD',
  'AE',
  'AU',
  'CA',
  'CH',
  'RO',
  'SA',
  'US',
  'AT',
  'LU',
  'MY',
  'MA',
  'UY',
  'KZ',
  'AZ',
  'MO',
  'GE',
  'LT',
  'DK',
  'IS',
  'FI',
  'BR',
  'MX',
];

export const OLD_ACTIVE_SOLID_PAYPAL_SITE = ['cv-lite', 'resume-example', 'resumedone'];

export const ACTIVE_SOLID_PAYPAL_SITE = Array.from(new Set([...OLD_ACTIVE_SOLID_PAYPAL_SITE, ...FEF_HOST]));

export const UPSELL_PAGE_DESIGN_1 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev1_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev1_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev1_feature3_desc',
  },
];

export const UPSELL_PAGE_DESIGN_2 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev2_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev2_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev2_feature3_desc',
  },
];

export const UPSELL_PAGE_DESIGN_3 = [
  {
    icon: <Design1Icon1 />,
    title: 'upsell_pagev1_feature1_title',
    subTitle: 'upsell_pagev2_feature1_desc',
  },
  {
    icon: <Design1Icon2 />,
    title: 'upsell_pagev1_feature2_title',
    subTitle: 'upsell_pagev2_feature2_desc',
  },
  {
    icon: <Design1Icon3 />,
    title: 'upsell_pagev1_feature3_title',
    subTitle: 'upsell_pagev2_feature3_desc',
  },
];

export const MergedApplyRWVar2Card = [
  {
    img: '/img/merge_var2_card1.png',
    name: 'merge_2_text_4',
    svg: <Texi />,
    designation: 'merge_2_text_5',
    span: 'merge_2_text_6',
    trade: 'merge_2_text_7',
    left_btn: 'merge_2_text_8',
    right_btn: 'merge_2_text_9',
  },
  {
    img: '/img/merge_var2_card2.png',
    name: 'merge_2_text_10',
    svg: <UserTrade />,
    designation: 'merge_2_text_11',
    span: 'merge_2_text_12',
    trade: 'merge_2_text_13',
    left_btn: 'merge_2_text_14',
    right_btn: 'merge_2_text_15',
  },
  {
    img: '/img/merge_var2_card3.png',
    name: 'merge_2_text_16',
    svg: <Clothes />,
    designation: 'merge_2_text_17',
    span: 'merge_2_text_18',
    trade: 'merge_2_text_19',
    left_btn: 'merge_2_text_20',
    right_btn: 'merge_2_text_21',
  },
];

export const MergedApplyRWList = [
  { listText: 'marge_1_text_2' },
  { listText: 'marge_1_text_3' },
  { listText: 'marge_1_text_4' },
];

export const MergedApplyVar3List = [
  { listText: 'marge_3_text_4' },
  { listText: 'marge_3_text_5' },
  { listText: 'marge_3_text_6' },
];

export const MergedApplyRWVar2IconsList = [
  { icon: <GoogleIcon />, companyName: 'Google' },
  { icon: <MicroSoftIcon />, companyName: 'Microsoft' },
  { icon: <AdobeIcon />, companyName: 'Adobe' },
  { icon: <DeltaAirIcon />, companyName: 'Delta Air' },
  { icon: <IkeaIcon />, companyName: 'Ikea' },
];

export const MergedApply1ImageDesign = [
  {
    icon: <ReviewIcon />,
    title: 'merge_1_img_block_text_1',
  },
  {
    icon: <EqualToIcon />,
    title: 'merge_1_img_block_text_2',
  },
  {
    icon: <UpArrowIcon />,
    title: 'merge_1_img_block_text_3',
  },
];
export const SUPPORTED_COUNTRY_CODES = new Set([
  'US',
  'CA',
  'GB',
  'IE',
  'FR',
  'DE',
  'IT',
  'ES',
  'PT',
  'AT',
  'BE',
  'DK',
  'FI',
  'NO',
  'SE',
  'CH',
  'NL',
  'PL',
  'CZ',
  'SK',
  'GR',
  'HU',
  'IS',
  'LU',
  'EE',
  'LV',
  'LT',
  'UA',
  'AU',
  'NZ',
  'CN',
  'HK',
  'JP',
  'SG',
  'KR',
  'TW',
  'MO',
  'MY',
  'IL',
  'SA',
  'AE',
  'QA',
  'BH',
  'KW',
  'BR',
  'MX',
  'CL',
  'CO',
  'PE',
  'CR',
  'RO',
  'BG',
  'HR',
  'SI',
  'IN',
  'PH',
  'TH',
  'ZA',
]);

export const BluePillCheckoutCardInfo = [
  {
    svg: <Card1Svg />,
    cardText1: 'bluepill_checkout_card1_text1',
    cardText2: 'bluepill_checkout_card1_text2',
  },
  {
    svg: <Card2Svg />,
    cardText1: 'bluepill_checkout_card2_text1',
    cardText2: 'bluepill_checkout_card2_text2',
  },
  {
    svg: <Card3Svg />,
    cardText1: 'bluepill_checkout_card3_text1',
    cardText2: 'bluepill_checkout_card3_text2',
  },
  {
    svg: <Card4Svg />,
    cardText1: 'bluepill_checkout_card4_text1',
    cardText2: 'bluepill_checkout_card4_text2',
  },
  {
    svg: <Card5Svg />,
    cardText1: 'bluepill_checkout_card5_text1',
    cardText2: 'bluepill_checkout_card5_text2',
  },
  {
    svg: <Card6Svg />,
    cardText1: 'bluepill_checkout_card6_text1',
    cardText2: 'bluepill_checkout_card6_text2',
  },
];

export const TestimonialInfoBluePill = [
  {
    imgPath: 'img/AutoApply/CheckoutUser1.webp',
    text1: 'bluepill_checkout_testimonial_data1_text1',
    text2: 'bluepill_checkout_testimonial_data1_text2',
    name: 'bluepill_checkout_testimonial_data1_name',
    designation: 'bluepill_checkout_testimonial_data1_designation',
  },
  {
    imgPath: 'img/AutoApply/CheckoutUser2.webp',
    text1: 'bluepill_checkout_testimonial_data2_text1',
    text2: 'bluepill_checkout_testimonial_data2_text2',
    name: 'bluepill_checkout_testimonial_data2_name',
    designation: 'bluepill_checkout_testimonial_data2_designation',
  },
];

export const DISABLE_APPLE_GOOGLE_PAY_SOLID_COUNTRY = [
  'AR',
  'BR',
  'PE',
  'CO',
  'EC',
  'MX',
  'PY',
  'SV',
  'HN',
  'ZA',
  'TR',
  'AU',
  'UA',
];

export const NON_TRAIL_COUNTRY_ABTEST = [];

export const MOBILE_AB_TEST_COUNTRY = [];

export const FULLY_NON_TRAIL_COUNTRY = [
  'ZA',
  'AU',
  'IN',
  'TH',
  'BO',
  'CR',
  'CN',
  'PY',
  'UA',
  'GR',
  'JO',
  'EG',
  'US',
  'BR',
  'MX',
  'CA',
  'PE',
  'AD',
  'FI',
  'ID',
  'TR',
  'PY',
  'PK',
  'IL',
  'NG',
  'NP',
  'IQ',
  'PS',
  'VE',
  'CU',
  'IR',
  'SV',
  'NI',
  'BD',
  'LK',
  'GT',
  'HN',
  'GW',
  'LS',
  'SB',
  'JE',
  'GQ',
  'AL',
  'GF',
  'PH',
  'SY',
  'TG',
  'UG',
  'KW',
  'GA',
  'ZW',
  'VN',
  'KE',
  'PL',
  'AR',
  'LB',
  'ME',
  'CN',
  'CY',
];

export const DOMAIN_WISE_NON_TRAIL_COUNTRY = {};

export const CLOSE_NON_TRIAL_COUNTRY = ['US'];

export const NEW_PRICING_NON_TRIAL_AB_TEST_COUNTRY = ['US'];

export const WINNER_NON_TRAIL_COUNTRY_ON_DESKTOP = [];

export const NEW_3_PLANS_NON_TRAIL_COUNTRY = ['US'];

export const INDIVIDUAL_NON_TRIAL_COUNTRY_ABTEST = [
  'IN',
  'ZA',
  'MX',
  'BR',
  'AD',
  'FI',
  'ID',
  'CA',
  'UA',
  'GR',
  'US',
  'PE',
  'CA',
  'AU',
  'SA',
  'ZA',
  'PY',
  'TR',
  'PK',
  'IL',
  'PH',
  'VN',
  'PL',
  'AR',
  'LB',
];

export const FULLY_QUARTERLY_COUNTRY = ['IN'];

export const NEW_DESIGN_FEATURE_V2_SECTION_DATA = [
  {
    icon: <NewlyIcon1 />,
    title: 'new_design_feature_title_1',
    subTitle: 'new_design_feature_subtitle_1',
  },
  {
    icon: <NewlyIcon2 />,
    title: 'new_design_feature_title_2',
    subTitle: 'new_design_feature_subtitle_2',
  },
  {
    icon: <NewlyIcon3 />,
    title: 'new_design_feature_title_3',
    subTitle: 'new_design_feature_subtitle_3',
  },
  {
    icon: <NewlyIcon4 />,
    title: 'new_design_feature_title_4',
    subTitle: 'new_design_feature_subtitle_4',
  },
  {
    icon: <NewlyIcon5 />,
    title: 'newly_left_title_5',
  },
  {
    icon: <NewlyIcon6 />,
    title: 'newly_left_title_6',
    subTitle: 'newly_left_subtitle_6',
  },
];

export const UNSUPPORTED_PAYPAL_CURRENCY = ['AED', 'COP', 'INR', 'PEN', 'SAR', 'TRY', 'VND', 'ZAR', 'PYG', 'CNY'];

export const UNSUPPORTED_PAYPAL_COUNTRY_NON_TRAIL = ['IN', 'PE', 'TR', 'VN', 'ZA', 'PY', 'CN'];

export const UNSUPPORTED_PAYPAL_COUNTRY_TRAIL = ['AE', 'CO', 'SA'];

export const UNSUPPORTED_REVOLUT_CURRENCY = [
  'ARS',
  'BRL',
  'COP',
  'EGP',
  'INR',
  'PHP',
  'RUB',
  'SAR',
  'THB',
  'AED',
  'CNY',
  'CLP',
  'VND',
  'PEN',
  'PYG',
  'KRW',
];

export const UNSUPPORTED_REVOLUT_COUNTRY_NON_TRAIL = ['EG', 'IN', 'PH', 'TH', 'PE', 'CN', 'CL', 'VN', 'PY', 'KR', 'BR'];

export const UNSUPPORTED_REVOLUT_COUNTRY_TRAIL = ['SA', 'RU', 'AE', 'CO'];

export const UNSUPPORTED_MOLLIE_COUNTRY_NON_TRAIL = ['TR', 'IN', 'PY', 'PE', 'VN', 'CN'];

export const UNSUPPORTED_MOLLIE_COUNTRY_TRAIL = ['EG', 'CO'];

export const UNSUPPORTED_MOLLIE_CURRENCY = [
  'TRY',
  'SAR',
  'ARS',
  'INR',
  'EGP',
  'COP',
  'IDR',
  'PYG',
  'PEN',
  'UAH',
  'VND',
  'CNY',
];

export const SOLID_DESIGN_ABTEST_COUNTRY = [
  'ES',
  'AD',
  'AU',
  'CH',
  'MS',
  'MO',
  'SE',
  'GB',
  'LT',
  'PT',
  'DK',
  'IS',
  'NO',
  'FI',
];

export const WINNER_SOLID_DESIGN_ABTEST_COUNTRY = ['GE', 'AZ', 'CZ', 'HR', 'ES', 'UY', 'KZ', 'DE', 'RO', 'AE'];

export const RESUME_IO_CHECKOUT_DATA = [
  {
    icon: <ResumeIO1 />,
    title: 'checkout_resumeio_point_1',
  },
  {
    icon: <ResumeIO2 />,
    title: 'checkout_resumeio_point_6',
  },
  {
    icon: <ResumeIO3 />,
    title: 'checkout_resumeio_point_7',
  },
  {
    icon: <ResumeIO4 />,
    title: 'checkout_resumeio_point_4',
  },
  {
    icon: <ResumeIO5 />,
    title: 'checkout_resumeio_point_5',
  },
];

export const CVEKSEMPEL_COUNTRIES = [
  'TH',
  'BO',
  'CR',
  'JO',
  'EG',
  'NG',
  'NP',
  'IQ',
  'PS',
  'VE',
  'CU',
  'IR',
  'SV',
  'NI',
  'BD',
  'LK',
  'GT',
  'HN',
  'GW',
  'LS',
  'SB',
  'JE',
  'GQ',
  'AL',
  'GF',
  'SY',
  'TG',
  'UG',
  'KW',
  'GA',
  'ZW',
  'KE',
];

export const RESUME_IO_CHECKOUT_WON_COUNTRIES = ['ES'];

export const RESUME_IO_CHECKOUT_COUNTRIES = ['LT', 'NL', 'IS', 'KR', 'CA'];

export const SOLID_CTA_DESKTOP_EXP_VAR_3_LOCALE = ['id', 'hr', 'bg'];

export const SOLID_CTA_DESKTOP_EXP_VAR_2_LOCALE = ['ka', 'hu', 'ko', 'pl', 'he', 'uk', 'sr'];

export const SOLID_CTA_DESKTOP_EXP_CONTROL_LOCALE = ['sv', 'th'];

export const SOLID_CTA_MOBILE_EXP_CONTROL_LOCALE = ['id'];

export const SOLID_CTA_MOBILE_EXP_VAR_1_LOCALE = ['hu'];
